import { FC } from "react";

interface IconProps {
  color?: string;
}

const Exit: FC<IconProps> = ({ color = "#525A6A" }) => (
  <svg viewBox="0 0 22 22" stroke={color} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.495 11.02H3.457M11.81 8.347l2.684 2.673-2.684 2.673"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M7.796 6.773v-.855a3.377 3.377 0 0 1 3.378-3.377h4.477A3.368 3.368 0 0 1 19.02 5.91V16.12a3.378 3.378 0 0 1-3.378 3.378h-4.478a3.369 3.369 0 0 1-3.368-3.368v-.864"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default Exit;
